
import { LinkedTG } from '@/api/Helpers'
import TicketTypeStepper from '@/components/events/TicketTypeStepper.vue'
import { hasSeated } from '@/helpers/TicketGroupHelpers'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'SelectGroupQuantities',
  components: {
    TicketTypeStepper,
  },
})
export default class extends Vue {
  @Prop({ required: true })
  ticketGroup: LinkedTG

  @Prop({ required: true })
  quantities: TicketTypeQuantities

  @Prop({ required: true })
  remainingCapacity: TicketTypeQuantities

  @Prop({ default: false })
  giftOfMembership: boolean

  @Prop({ default: false })
  showHeaders: boolean

  @Prop({ default: false })
  showAdvertisedFees: boolean

  @Prop({ default: false })
  exactlyOneTicket: boolean

  get showName(): boolean {
    const tg = this.ticketGroup
    if (this.isSeated) {
      return true
    } else {
      return tg.description.length > 0 && tg.description !== tg.name
    }
  }

  get isSeated(): boolean {
    return hasSeated([this.ticketGroup])
  }

  get className(): string | null {
    return this.isSeated ? `ticket-group-${this.ticketGroup.color}-color` : null
  }

  get groupMinQuantity(): number {
    const group = this.ticketGroup
    // Only apply the minimum guard when the group has a single ticket type
    if (group.types.length === 1 && group.min_tickets_per_order) {
      return Math.max(Number(group.min_tickets_per_order), 1)
    } else {
      return 1
    }
  }
}
